import heroImage from "../assets/image1.jpg";
import gateImage from "../assets/image10.jpg";
import corporateImage from "../assets/image2.jpg";
import retailImage from "../assets/image3.jpg";
import manufacturingImage from "../assets/image4.jpg";
import residentialImage from "../assets/image5.jpg";
import constructionImage from "../assets/image6.jpg";
import eventsImage from "../assets/image7.jpg";
import patrolImage from "../assets/image8.jpg";
import controlRoomImage from "../assets/image9.jpg";
import passportImage from "../assets/passport.jpg";

export const companyInfo = {
  name: "Runzewe Security",
  fullName: "Runzewe Security Company Limited",
  shortName: "RSC",
  tagline: "Professional. Reliable. Always Alert.",
  promise: "Safety, Discipline, and Integrity",
  established: "October 2019",
  incorporationDate: "22 October 2019",
  registrationNo: "140216445",
  tin: "140-216-445",
  phone: "+255 769 771 171",
  whatsapp: "+255 715 771 677",
  email: "runzewescltd@gmail.com",
  address:
    "Masanja's House, Busonzo Village, Runzewe-Bwanga Road, Bukombe District, Geita Region, Tanzania",
  mailingAddress: "P.O. Box 88, Geita, Tanzania",
  darOffice: "Kibamba, Dar es Salaam",
  websiteDeveloper: "Werenium Technologies",
  developerUrl: "https://werenium.com",
  heroImage,
  gateImage,
  patrolImage,
  controlRoomImage,
  passportImage,
};

export const socialLinks = [
  {
    label: "Facebook",
    url: "https://www.facebook.com/search/top?q=Runzewe%20Security%20Company%20Limited",
  },
  {
    label: "Instagram",
    url: "https://www.instagram.com/runzewesecurity/",
  },
  {
    label: "WhatsApp",
    url: "https://wa.me/255715771677",
  },
];

export const stats = [
  {
    label: "Established",
    value: "2019",
    detail: "Years of excellence",
  },
  {
    label: "24/7",
    value: "Monitoring",
    detail: "Always on guard",
  },
  {
    label: "Licensed &",
    value: "Trusted",
    detail: "Fully licensed and compliant",
  },
  {
    label: "Nationwide",
    value: "Coverage",
    detail: "Across Tanzania",
  },
];

export const strengths = [
  {
    title: "Licensed & Compliant",
    description: "Permitted by the Office of the Inspector General of Police.",
  },
  {
    title: "Professional Team",
    description: "Trained officers, supervisors, and operational leadership.",
  },
  {
    title: "Proven Reliability",
    description: "Serving schools, health facilities, hotels, residences, and businesses.",
  },
  {
    title: "Client-Focused Approach",
    description: "Security solutions tailored to each site and risk profile.",
  },
];

export const principles = [
  {
    title: "Vision",
    description:
      "To be the integrated security solutions provider of choice through exceptional quality, personnel, integrity, innovative systems, and customer relations across Tanzania.",
  },
  {
    title: "Mission",
    description:
      "To support sustainable safety and security for customers and communities through people, innovation, and a commitment to social responsibility.",
  },
  {
    title: "Values",
    description: "Quality, discipline, loyalty, integrity, truth, honour, and safety.",
  },
];

export const services = [
  {
    title: "Manned Guarding",
    short:
      "Trained personnel for static and mobile guarding with strong discipline and presence.",
    details:
      "Day and night guards, armed and unarmed officers, reception support, car guards, and site-specific protection plans.",
  },
  {
    title: "Mobile Patrol",
    short:
      "Visible deterrence through regular patrols, supervision, and rapid response.",
    details:
      "Mobile patrols strengthen site visibility, support supervisors, and help respond quickly to incidents across assigned routes.",
  },
  {
    title: "Electronic Security",
    short:
      "CCTV, access control, alarms, and integrated security systems.",
    details:
      "Supply, installation, and maintenance of CCTV, biometric access, card access, digital zoning, and 24-hour control room monitoring.",
  },
  {
    title: "Event Security",
    short:
      "Professional crowd management and event protection for every scale.",
    details:
      "Crowd control, gate management, VIP close protection, escort services, and safety coordination for venues and public events.",
  },
  {
    title: "Risk Assessment",
    short:
      "Security audits, investigations, intelligence, and practical control measures.",
    details:
      "Risk management, crime mapping, security audits, investigations, and health, safety, and environment training support.",
  },
  {
    title: "Secure Operations",
    short:
      "End-to-end security support for facilities, assets, people, and critical operations.",
    details:
      "Integrated guarding, technical services, supervision, reporting, and customized security procedures for long-term protection.",
  },
];

export const industries = [
  {
    title: "Corporate Offices",
    image: corporateImage,
  },
  {
    title: "Retail & Malls",
    image: retailImage,
  },
  {
    title: "Manufacturing",
    image: manufacturingImage,
  },
  {
    title: "Residential Estates",
    image: residentialImage,
  },
  {
    title: "Construction Sites",
    image: constructionImage,
  },
  {
    title: "Events & Venues",
    image: eventsImage,
  },
];

export const targetClients = [
  "Commercial and residential buildings",
  "Construction sites and warehouses",
  "Factories and industries",
  "Mining and quarries",
  "Railways and transmission towers",
  "Government institutions and NGOs",
  "Financial institutions",
  "Hospitals and health facilities",
  "Schools and training institutions",
  "Hotels, restaurants, lodges, and event venues",
];

export const currentClients = [
  "Runzewe Secondary School - Geita",
  "Charles Kulwa Memorial Health Centre - Geita",
  "Uyovu Health Centre - Geita",
  "Pavics Company Limited Hotel Project - Geita",
  "Busonzo Primary & Secondary Schools - Geita",
  "Hon. Dotto Mashaka Biteko Residence - Geita",
  "Shirima Petrol Station - Runzewe, Geita",
  "Magufuli High School - Geita",
  "Citizen Pre & Primary Schools - Geita",
  "Busonzo Roman Catholic Church - Geita",
  "Ibamba Market - Bukombe, Geita",
  "Fun Beach Hotel - Jambiani, Zanzibar",
  "Bwejuu Apartments - Zanzibar",
  "Paje by Night - Zanzibar",
  "Safaya Luxury Villa - Nungwi, Zanzibar",
  "Sunset Bay - Michamvi, Zanzibar",
];

export const regions = [
  "Geita",
  "Mwanza",
  "Dar es Salaam",
  "Pwani",
  "Dodoma",
  "Kagera",
  "Kigoma",
  "Singida",
  "Shinyanga",
  "Tabora",
  "Zanzibar",
];

export const organization = [
  {
    level: "Ownership",
    people: ["PAVICS Company Limited", "Paul Bwire Masanja", "Edgar R. Rutatina"],
  },
  {
    level: "Board of Directors",
    people: [
      "Jackson Wisaka Kirahuka - Chairperson",
      "Eng. Simon Paul Masanja - Member",
      "Edgar Rutashoborwa Rutatina - Member",
      "Mashaka Bernard Mwingira - Member",
      "Victor Paul Masanja - Member",
      "Paul Bwire Masanja - CEO/Secretary",
    ],
  },
  {
    level: "Management Team",
    people: [
      "CEO - Paul B. Masanja",
      "FAO - Victor P. Masanja",
      "CMO - Boaz J. Kifata",
      "CI - Jackson W. Kirahuka",
      "Operations Officer - Edward A Ernest",
    ],
  },
  {
    level: "Field Operations",
    people: ["Supervisors", "Technical/supporting staff", "Security guards"],
  },
];

export const keyPersonnel = [
  {
    name: "Paul B. Masanja",
    role: "Chief Executive Officer",
    summary:
      "Overall in charge of day-to-day company leadership, strategy, and administration.",
  },
  {
    name: "Edgar R. Rutatina",
    role: "Director of Operations",
    summary:
      "Leads operational coordination and field execution for client assignments.",
  },
  {
    name: "Jackson Wisaka Kirahuka",
    role: "Chief Instructor",
    summary:
      "Retired police officer responsible for technical training and guard readiness.",
  },
  {
    name: "Victor Paul Masanja",
    role: "Finance & Administrative Officer",
    summary:
      "Supports finance, administration, and internal management controls.",
  },
  {
    name: "Boaz Joshua Kifata",
    role: "Chief Marketing Officer",
    summary:
      "Coordinates market growth, client relationships, and service visibility.",
  },
  {
    name: "Edward Akome Ernest",
    role: "Operations Officer",
    summary:
      "Supports site operations, deployment, and day-to-day field supervision.",
  },
];

